import { createSelector } from "reselect";

const currentState = (state) => state;

export const retrieveCurrentReviewableAction = createSelector(
  currentState,
  (st) => st.currentActionToReview
);
